import { useEffect } from "react";
import { useQuery, useSubscription, useMutation } from "@apollo/client";

import { useDispatch } from "react-redux";
import { combineVirtualGaps } from "../../../state/virtualGapsReducer";
import {
  MUTATE_PIT_STOP_LOSS,
  MUTATE_REF_LAP_TIME,
  QUERY_VIRTUAL_GAPS,
  SUBSCRIBE_VIRTUAL_GAPS,
} from "../queries/virtualGapsQueries";

export function QueryVirtualGaps() {
  const dispatch = useDispatch();
  const { data, loading, error } = useQuery(QUERY_VIRTUAL_GAPS);
  if (error) {
    console.log(error);
  }
  useEffect(() => {
    if (data) {
      dispatch(combineVirtualGaps(data.getVirtualGaps));
    }
  }, [dispatch, data, loading, error]);
}

export function SubscribeVirtualGaps() {
  const dispatch = useDispatch();
  const { error } = useSubscription(SUBSCRIBE_VIRTUAL_GAPS, {
    onData: (x) => {
      dispatch(combineVirtualGaps(x.data.data.virtualGapsUpdate));
    },
  });
  if (error) {
    console.log(error);
  }
}

export function MutateRefLapTime() {
  const [updateReferenceLapTime] = useMutation(MUTATE_REF_LAP_TIME);
  return updateReferenceLapTime;
}

export function MutatePitStopLoss() {
  const [updatePitStopLoss] = useMutation(MUTATE_PIT_STOP_LOSS);
  return updatePitStopLoss;
}
